<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Overseas Freight Consolidation</b-navbar-brand>
          <b-navbar-nav class="ml-auto">
            <b-nav-form>
              <Filter-Agency-Modal />
              <FilterCBModal />
              <ClientCard />
               <ShipmentTrackCard />
              <!-- <b-button @click="goToMain" size="sm" variant="warning">New Assignment</b-button> -->
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <div>
          <div class="row">
            <div class="col-md-6">
              <b-form-group>
                <b-input-group>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="filter"
                    placeholder="Type To Search (Assignment No. / Client / Container No. / Shipping BL No / SHipping Invoice No / MBL / HBL )"
                  />
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </div>
            <b-col class="col-md-3">
              <label for="blType">To</label>
              <model-list-select
                :list="$store.getters['common/getAllAgentColoaderList']"
                option-value="agentName"
                option-text="agentName"
                v-model="ToFilter"
                placeholder="Select To"
                @input="viewFFExportFCL('0', '0', '1', '1')"
              ></model-list-select>
            </b-col>
            <b-col class="col-md-3">
              <label for="blType">Agent</label>
              <model-list-select
                :list="$store.getters['commonDropdownMaster/getAllAgentDDList']"
                option-value="value"
                option-text="text"
                v-model="agentFilter"
                placeholder="Select Agent"
                @input="viewFFExportFCL('0', '0', '1', '1')"
              ></model-list-select>
            </b-col>
            <div class="col-md-2">
              <label>CLOSE STATUS</label>
              <model-list-select
                @input="viewFFExportFCL('0', '0', '1', '1')"
                :list="CLosedStatusList"
                v-model="closedFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Close Status"
              ></model-list-select>
            </div>
            <div class="col-md-2">
              <label for="blType">Incoterm</label>
              <model-list-select @input="viewFFExportFCL('0', '0', '1', '1')" :list="deliveryTermsList" v-model="termFilter" option-value="value"
              option-text="text" placeholder="Select Incoterm"  />
            </div>
            <div class="col-md-2">
              <label>SOB FILTER</label>
              <model-list-select
                @input="viewFFExportFCL('0', '0', '1', '1')"
                :list="SOBStatusList"
                v-model="SOBFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select SOB Status"
              ></model-list-select>
            </div>
            <b-col class="col-md-2">
              <label>MANIFESTATION STATUS</label>
              <model-list-select
                @input="viewFFExportFCL('0', '0', '1', '1')"
                :list="ManifestationStatusList"
                v-model="manifestationFilter"
                option-value="inv"
                option-text="int"
                placeholder="Select Manifestation"
              ></model-list-select>
            </b-col>
          </div>
          <div>
            <h5 class="text-muted pull-right">
              <small>{{ totalRows }} Entries</small>
            </h5>
          </div>
        </div>
        <div class="table-responsive tableMain">
          <!-- Main table element -->
          <b-table
            show-empty
            stacked="md"
            :items="FFExport"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template slot="ffFclConsoExportId" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="ffExportFclConsoSeries" slot-scope="row01">
              <div
                @click="
                  row01.item.is_locked == '1' &&
                  (row01.item.finalBillingCompleted == 1 || row01.item.locked_counter > 0)
                    ? ''
                    : viewExportFCLConPage(row01.item.ffFclConsoExportId)
                "
                class="showMoreData"
              >
                <!-- @click="row01.item.finalBillingCompleted == 0?viewExportFCLConPage(row01.item.ffFclConsoExportId):''" -->
                <span>
                  Assignment No.: {{ row01.item.ffExportFclConsoSeries }}
                  <br />
                </span>
                <span>
                  Raised From: {{ row01.item.EmpLoc }}
                  <br />
                </span>
                <span>
                  Date : {{ row01.item.loginTime | moment }}
                  <br />
                </span>
                <b-button
                  style="font-size: 0.675rem"
                  class="mt-2"
                  size="sm"
                  @click="
                    row01.item.is_locked == '1' &&
                    (row01.item.finalBillingCompleted == 1 ||
                      row01.item.locked_counter > 0)
                      ? LockUnLock(row01.item, 'locked')
                      : ''
                  "
                  :variant="
                    row01.item.is_locked == '1' &&
                    (row01.item.finalBillingCompleted == 1 ||
                      row01.item.locked_counter > 0)
                      ? 'danger'
                      : 'success'
                  "
                >
                  <b
                    v-if="
                      row01.item.is_locked == '1' &&
                      (row01.item.finalBillingCompleted == 1 ||
                        row01.item.locked_counter > 0)
                    "
                  >
                    <i class="fa fa-lock mr-1 lg"></i>LOCKED
                  </b>
                  <b v-else> <i class="fa fa-unlock mr-1 lg"></i>UN-LOCKED </b>
                </b-button>
                <br />
                <!-- <span v-if="row01.item.finalBillingCompleted == '1'">
                  <b :style="'color:black'">Billing :</b>
                  <b-badge variant="success">
                    <b>Completed</b>
                  </b-badge>
                  <br />
                </span> -->


                
                <!-- <span v-if="row01.item.finalBillingCompleted == '0'">
                  <b :style="'color:black'">Billing :</b>
                  <b-badge variant="danger">
                    <b>Pending</b>
                  </b-badge>
                  <br />
                </span> -->
                  <span v-if="row01.item.enquiry_booking_no">BRF No : {{ row01.item.enquiry_booking_no }}<br /></span>
                  <span v-if="row01.item.inco_term">Inco Term : {{ row01.item.inco_term }}<br /></span>
                  
                <b :style="'color:black'">Billing : </b>
                <b-badge variant="success" v-if="(row01.item.finalBillingCompleted == '1')">Billing Completed</b-badge>
                <b-badge v-else-if="row01.item.finalBillingCompleted == '4'" variant="success">Billing Completed - Agent Expense Pending</b-badge>
                <b-badge v-else variant="danger">Billing In-complete</b-badge><br/>
                <span
                  v-if="
                    row01.item.sob_date_detected != '' &&
                    row01.item.sob_date_detected != null
                  "
                >
                  <b :style="'color:black'">SOB : {{ row01.item.sob_date_detected }}</b>
                  <b-badge variant="danger">
                    <b>SAILED</b>
                  </b-badge>
                </span>
              </div>

              <b-button
                class="mt-2"
                style="font-size: 0.675rem"
                size="sm"
                @click="showDocModal(row01.item)"
                variant="outline-info"
                >Summary & Documents</b-button
              >
              <br />
              <Assignment-Summary
                :title="'Shipment Summary Tracking - '"
                :fk_all_module_id="row01.item.allModuleId"
                :jb_series="row01.item.ffExportFclConsoSeries"
              />
              <ContainerSummary
                v-if="row01.item.allModuleId"
                :PMC_title="
                  'Container Summary Job No - ' + row01.item.ffExportFclConsoSeries
                "
                :PMC_JOBID="row01.item.allModuleId"
                :PMC_JOBNO="row01.item.ffExportFclConsoSeries"
                :PMC_JOBDATE="''"
                :PMC_JOBTYPE="''"
                :PMC_AgentType="''"
                :PMC_Client="''"
                :PMC_Sline="''"
              />
              <!-- <JobWisePaymentsDetails
                  v-if="row01.item.allModuleId"
                  :allModuleId="Number(row01.item.allModuleId)"
                  :JobNo="row01.item.ffExportFclConsoSeries"
                  /> -->
            </template>
            <template slot="clientName" slot-scope="row112">{{
              uniqueString(row112.item.clientName)
            }}</template>
            <template slot="placeRecp" slot-scope="row11">
              <div>
                <span>
                  Agent Name : {{ row11.item.agentName }}
                  <br />
                </span>
                <span>
                  Shipping Line : {{ row11.item.shippingLine }}
                  <br />
                </span>
                <span>
                  POR : {{ row11.item.placeRecp }}
                  <br />
                </span>

                <span>
                  Load Port : {{ row11.item.LoadPort }}
                  <br />
                </span>
                <span>
                  POD : {{ row11.item.placeDis }}
                  <br />
                </span>
                <span>
                  FPOD : {{ row11.item.finalPlace }}
                  <br />
                </span>
              </div>
            </template>

            <template slot="MBL" slot-scope="row18">
              <span>
                MBL NO.:- {{ row18.item.master_linerBLNumber }}
                <br />
              </span>
              <span>
                HBL NO.:- {{ row18.item.house_BLNumber }}
                <br />
              </span>
              <span v-if="row18.item.allContainer.length > 0">
                <b>CONT NO.:-</b>
                <b v-if="row18.item.allContainer[0].fclConcontainerNo">{{ wordWrap(row18.item.allContainer[0].fclConcontainerNo, 24) }}</b>
                <br />
              </span>
              <span v-if="row18.item.containersTypes">
                <b>CONT TYPE.:-</b>
                <b  v-if="row18.item.containersTypes">{{ wordWrap(row18.item.containersTypes, 24) }}</b>
              </span>
              <br />
            </template>

            <template slot="action" slot-scope="row3">
              <!-- row3.item.CountmainManifestationData > 0
                    ? openNoteModal(2, row3.item)
                    : '' -->
              <b-button
                :disabled="row3.item.closedOverseas_status == 0 ? true : false"
                v-if="row3.item.debitcount >= 1"
                @click="
                  row3.item.CountmainManifestationData > 0
                    ? openNoteModal(2, row3.item)
                    : ''
                "
                size="sm"
                variant="outline-success"
                >Debit Note</b-button
              >
              <b-button
                :disabled="row3.item.closedOverseas_status == 0 ? true : false"
                v-if="row3.item.debitcount <= 0"
                @click="
                  row3.item.CountmainManifestationData > 0
                    ? openNoteModal(2, row3.item)
                    : ''
                "
                size="sm"
                variant="outline-danger"
                >Debit Note</b-button
              >
              <!-- row3.item.CountmainManifestationData > 0
                    ? openNoteModal(1, row3.item)
                    : '' -->
              <b-button
                :disabled="row3.item.closedOverseas_status == 0 ? true : false"
                v-if="row3.item.creditcount >= 1"
                class="mb-1"
                @click="
                  row3.item.CountmainManifestationData > 0
                    ? openNoteModal(1, row3.item)
                    : ''
                "
                size="sm"
                variant="outline-success"
                >Credit Note</b-button
              >
              <b-button
                :disabled="row3.item.closedOverseas_status == 0 ? true : false"
                v-if="row3.item.creditcount <= 0"
                class="mb-1"
                @click="
                  row3.item.CountmainManifestationData > 0
                    ? openNoteModal(1, row3.item)
                    : ''
                "
                size="sm"
                variant="outline-danger"
                >Credit Note</b-button
              >
              <b-button
                v-if="!row3.item.preAlertDate"
                @click="checkActions(row3.item)"
                size="sm"
                variant="outline-danger"
                >Send Pre-Alert</b-button
              >
              <div v-else>
                <br />
                <b-badge class="p-2" variant="success">
                  <b>PreAlert sent on {{ row3.item.preAlertDate }}</b>
                  <br />
                  <br />
                  <b>by {{ row3.item.preAlertRaisedBy }}</b>
                </b-badge>
              </div>
              <b-badge
                v-if="
                  row3.item.frghtTermsMbl == 'Collect' &&
                  row3.item.frghtTermsHbl == 'Collect' &&
                  row3.item.closedOverseas_status == 1 &&
                  row3.item.creditDebitNoteType != 1 &&
                  row3.item.creditDebitNoteType != '' &&
                  !checkcreditDebitNote_Status(row3.item.NoteDetails)
                "
                class="p-2 mb-1"
                @click="checkActions(row3.item)"
                variant="warning"
              >
                <b>Credit Note Pending</b>
                <br />
              </b-badge>
              <!-- <b-button
             
                v-if="!row3.item.creditDebitNoteType"
                @click="checkActions(row3.item)"
                size="sm"
                variant="outline-danger"
                >Debit / Credit Note</b-button
              >-->
              <div>
                <br />
                <span v-for="(CDitem, CD_index) in row3.item.NoteDetails" :key="CD_index">
                  <b-badge
                    class="p-2 ml-2 mb-1"
                    variant="warning"
                    :creditNoteStatus="CDitem.creditDebitNote_Status"
                    v-if="
                      CDitem.uploadCreditDebit != '' &&
                      CDitem.approvalStatus == '1' &&
                      CDitem.creditDebitNoteType == '1'
                    "
                    @click="
                      PrintNote(
                        row3.item.ffExportFclConsoSeries,
                        CDitem.uploadCreditDebit
                      )
                    "
                    size="sm"
                  >
                    <span v-if="CDitem.creditDebitNoteType == '1'">Credit Note PDF</span>
                  </b-badge>

                  <b-badge
                    class="p-2 mb-1"
                    variant="warning"
                    v-if="
                      CDitem.uploadCreditDebit != '' &&
                      CDitem.approvalStatus == '1' &&
                      CDitem.creditDebitNoteType == '2'
                    "
                    @click="
                      PrintNote(
                        row3.item.ffExportFclConsoSeries,
                        CDitem.uploadCreditDebit
                      )
                    "
                    size="sm"
                  >
                    <span v-if="CDitem.creditDebitNoteType == '2'">Debit Note</span>PDF
                    <br />
                  </b-badge>
                </span>
                <!-- <b-badge class='p-2 m-b-4' variant="warning" 
                v-if="row3.item.uploadCreditDebit != '' && row3.item.approvalStatus=='1'"
                @click="PrintNote(row3.item.ffExportFclConsoSeries,row3.item.uploadCreditDebit)"
                size="sm"
                ><span v-if="row3.item.creditDebitNoteType=='1'">Credit Note </span>
                <span v-else>Debit Note </span>PDF<br/></b-badge>-->

                <!-- <b-badge class='p-2 m-b-4' variant="warning" 
                v-if="row3.item.ffExportFclConsoSeries=='FFCon/Exp/MOR/15715/2021-22' && row3.item.uploadCreditDebit != '' && row3.item.approvalStatus=='1' && row3.item.creditDebitNoteType=='2'"
                @click="PrintNote(row3.item.ffExportFclConsoSeries,'Approved-DEBIT -2022-02-03 11:37:17.pdf')"
                size="sm"
                ><span v-if="row3.item.creditDebitNoteType=='1'">Credit Note </span>
                <span v-else>Debit Note </span>PDF<br/></b-badge>
                {{row3.item.NoteDetails}}-->

                <br />
                <b-badge class="p-2 m-t-2" variant="success">
                  <b>
                    Debit / Credit Generated on
                    {{ row3.item.creditDebitTime }}
                  </b>
                  <br />
                </b-badge>
              </div>

              <br />
              <b-button
                v-if="row3.item.portLocationType == 'USA' && !row3.item.amsTime"
                @click="checkActions(row3.item)"
                size="sm"
                variant="outline-danger"
                >AMS Filed</b-button
              >
              <b-badge
                v-else-if="row3.item.portLocationType == 'USA' && row3.item.amsTime"
                variant="info"
              >
                AMS on {{ row3.item.amsTime }}
                <br />
              </b-badge>

              <b-button
                v-if="row3.item.portLocationType == 'USA' && !row3.item.isfTime"
                @click="checkActions(row3.item)"
                size="sm"
                variant="outline-danger"
                >ISF Filed</b-button
              >
              <b-badge
                v-else-if="row3.item.portLocationType == 'USA' && row3.item.amsTime"
                variant="info"
              >
                ISF on {{ row3.item.isfTime }}
                <br />
              </b-badge>
              <br />
            </template>
            <template slot="eta_details" slot-scope="row321">
              <span v-if="row321.item.ETA_destination_estimated != ''"
                >Tentative : {{ row321.item.ETA_destination_estimated }}</span
              >
              <span v-if="row321.item.ETA_destination_actual != ''">
                <br />
                Actual : {{ row321.item.ETA_destination_actual }}
              </span>
            </template>
            <template slot="manifestation" slot-scope="row3">
              <!-- {{row3.item.fclConAlertId}} -->
              
              <span v-if="row3.item.CountmainManifestationData <= 0">
                <b-button size="sm" variant="outline-danger">Pending</b-button>
              </span>
              <span
                v-else-if="row3.item.CountmainManifestationData > 0"
                variant="success"
              >
                <b-button
                  @click="sendMANIFESTATION(row3.item)"
                  size="sm"
                  variant="success"
                  >Received</b-button
                >
              </span>
              <b-badge variant="danger" v-if="row3.item.newManiFestCount>0"><b>New Manifestation {{row3.item.newManiFestCount}}</b><br/></b-badge
                >
            </template>
            <template slot="closed" slot-scope="row3">
              <span v-if="row3.item.closedOverseas_status == 1">
                <b-button
                  @click="openCloseOverseasModal(row3.item)"
                  size="sm"
                  class="mb-1"
                  variant="outline-danger"
                  >Close</b-button
                >
              </span>
              <span v-else-if="row3.item.closedOverseas_status == 0" variant="success">
                <b-button size="sm" variant="success">Closed</b-button>
                <br />
                User:{{ row3.item.closedOverseas_byuser }}
                <br />
                Date:{{ row3.item.closedOverseas_created_at }}
              </span>
              <span v-for="(CDitem, CD_index) in row3.item.NoteDetails" :key="CD_index">
                <EditCRDRNote
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
                    CDitem.noteSeries
                  "
                  :title="
                    'Edit ' +
                    (CDitem.creditDebitNoteType === '2' ? 'Debit' : 'Credit') +
                    ' Note : ' +
                    CDitem.noteSeries
                  "
                  :note_id="CDitem.note_id"
                  :noteSeries="CDitem.noteSeries"
                  :note_page="CDitem.page"
                  :AgentType="CDitem.agentType"
                  :creditDebitNoteType="CDitem.creditDebitNoteType"
                  :approvalStatus="CDitem.approvalStatus"
                  :uploadCreditDebit="CDitem.uploadCreditDebit"
                  :creditDebitNote_Status="CDitem.creditDebitNote_Status"
                  :JOBID="row3.item.allModuleId"
                  :JOBNO="row3.item.ffExportFclConsoSeries"
                  :JOBDATE="row3.item.loginTime"
                  :JOBTYPE="row3.item.jobType"
                />
              </span>
              <CommonOverseaUnLock
                v-if="row3.item.closedOverseas_status == '0'"
                :title="'Open Overseas FCL Consolidation Assignment'"
                :Overlock_item="row3.item"
                :Overlock_JOBNO="row3.item.ffExportFclConsoSeries"
                :Overlock_allModuleId="row3.item.allModuleId"
                :Overlock_table_name="'frght_fclconsolidationexport'"
                :Overlock_table_key="'ffFclConsoExportId'"
                :Overlock_table_value="row3.item.ffFclConsoExportId"
                :Overlock_column_key="'closedOverseas_status'"
                :Overlock_column_value="row3.item.closedOverseas_status"
                :Overlock_module_type="'Overseas FCL Consolidation Freight Forwarding'"
              />
              <Add-Message
                :fk_all_module_id="row3.item.allModuleId"
                :fk_client_id="row3.item.clientId"
                :fk_pod_id="row3.item.PODLocationId"
                style="list-style-type: none"
              />
            </template>
          </b-table>
        </div>
        <b-row>
          <b-col md="12" class="my-1">
            <b-pagination
              limit="5"
              align="center"
              :total-rows="totalRows"
              :per-page="perPage"
              v-model="currentPage"
            />
          </b-col>
        </b-row>
      </b-card-text>
    </b-card>
    <div>
      <b-modal
        size="xl"
        id="doc"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES"
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close</b-button
        >
      </b-modal>
      <b-modal
        id="modal-lock-conf"
        ref="modal-lock-conf"
        title="Reason for Open Locked Assignment"
        centered
        no-close-on-esc
        no-close-on-backdrop
        hide-footer
      >
        <h3>Confirmation</h3>
        <form ref="form">
          <b-form-group
            label="Remark"
            label-for="name-input"
            invalid-feedback="Name is required"
          >
            <b-form-textarea
              :formatter="capitalizeAll"
              rows="5"
              id="name-input"
              v-model="lockReason"
              required
            ></b-form-textarea>
          </b-form-group>
        </form>
        <b-button @click="closeLockUnLockConfirm" variant="danger">Cancel</b-button>
        <b-button
          v-if="lockReason"
          :disabled="lock_button ? true : false"
          variant="success"
          class="pull-right"
          @click="ConfLock"
          >Send</b-button
        >
      </b-modal>
    </div>
    <!-- Modal Section Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="md"
      ref="CloseOverseas-modal"
      hide-footer
      title
    >
      <div class="d-block text-center">
        <h3>Are you sure to want close</h3>
      </div>

      <center>
        <span class="center">
          <b-button class="mt-3" variant="success" @click="SaveCloseOverseas"
            >Yes</b-button
          >
          <b-button class="mt-3" variant="danger" @click="hideCloseOverseasModal"
            >No</b-button
          >
        </span>
      </center>
    </b-modal>
    <!-- Modal Section End -->

    <!-- Added By Priyanshu SIngh STart -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="note-modal"
      hide-footer
      :title="
        noteModal.creditDebitNoteType == '1'
          ? 'CREDIT NOTE - ' + noteModal.ffExportFclConsoSeries
          : 'DEBIT NOTE - ' + noteModal.ffExportFclConsoSeries
      "
    >
      <div class="d-block text-center">
        <!-- <h3>
          {{
            noteModal.creditDebitNoteType == "1" ? "CREDIT NOTE" : "DEBIT NOTE"
          }}
        </h3>
        <br />-->
        <h4 class="error">
          {{
            noteModal.approvalStatus == "1"
              ? "Approved"
              : noteModal.sentForApproval == "1"
              ? "Sent for approval"
              : ""
          }}
        </h4>
      </div>
      <b-row>
        <b-col cols="10">
          <b-button
            v-if="noteModal.uploadCreditDebit != '' && noteModal.approvalStatus == '1'"
            @click="PrintNote(noteModal.uploadCreditDebit)"
            size="sm"
            variant="warning"
            >PDF</b-button
          >
          <b-button @click="addContent" size="sm">
            Add Particulars
            <i class="fa fa-plus-circle ml-1"></i>
          </b-button>
        </b-col>
        <b-col cols="10">
          <span v-if="noteModal.creditcount >= 1 && noteModal.creditDebitNoteType == '1'">
            <span class="error">Credit Note No. :</span>
            {{ noteModal.creditnoteSeriesDetailsCount }}
          </span>
          <span v-if="noteModal.debitcount >= 1 && noteModal.creditDebitNoteType == '2'">
            <span class="error">Debit Note No. :</span>
            {{ noteModal.debitnoteSeriesDetailsCount }}
          </span>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" class="mt-2">
          <label for="blType">Type <span class="error">*</span></label>

          <model-list-select
            :list="agentTypeList"
            option-value="TypeVal"
            option-text="TypeTxt"
            v-model="noteModal.agentType"
            placeholder="Select Type"
            @input="getAgentConsigneeList(noteModal.agentType)"
          ></model-list-select>
          <span class="error" v-if="!noteModal.agentType">{{
            errorCDNote.agentType
          }}</span>
        </b-col>
        <b-col cols="4">
          <label for="blType">
            To
            <span class="error">*</span>
          </label>

          <!-- :list="AgentColoaderList" -->
          <model-list-select
            :list="getAllAgentColoaderList"
            option-value="agentName"
            option-text="agentName"
            v-model="noteModal.AgentColoader"
            :placeholder="
              noteModal.agentType == 'Consignee'
                ? 'Select Consignee'
                : 'Select Agent/Coloader'
            "
            @input="getConsigneeAgentDetails"
          ></model-list-select>
          <span class="error" v-if="!noteModal.AgentColoader">
            {{ errorCDNote.AgentColoader }}
          </span>
        </b-col>
        <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Consignee'">
          <label for="Consignee Address">
            Consignee Address
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.agentconsigneeAddress"
            type="text"
            placeholder="Enter Consignee Address"
          ></b-form-input>
          <span class="error" v-if="!noteModal.agentconsigneeAddress">{{
            errorCDNote.agentconsigneeAddress
          }}</span>
        </b-col>
          <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Agent'">
          <label for="Agent Country">
            Agent Country
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.agent_country"
            type="text"
            placeholder="Enter Agent Country"
          ></b-form-input>
          <span class="error" v-if="!noteModal.agent_country">{{
            errorCDNote.agent_country
          }}</span>
        </b-col>

        <b-col cols="4" class="mt-2">
          <label for="Vessel/Voy">
            Vessel/Voy
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.vesselVoy"
            type="text"
            placeholder="Enter Vessel Voy"
          ></b-form-input>
          <span class="error" v-if="!noteModal.vesselVoy">{{
            errorCDNote.vesselVoy
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="HBL/AWB">
            HBL/AWB
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.BLNumber"
            type="text"
            placeholder="Enter HBL/AWB"
          ></b-form-input>
          <span class="error" v-if="!noteModal.BLNumber">{{ errorCDNote.BLNumber }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="MBL/MAWB">
            MBL/MAWB
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.masterorLinerBlNo"
            type="text"
            placeholder="Enter MBL/MAWB"
          ></b-form-input>
          <span class="error" v-if="!noteModal.masterorLinerBlNo">{{
            errorCDNote.masterorLinerBlNo
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SHIPPER">
            SHIPPER
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.clientNameM"
            type="text"
            placeholder="Enter SHIPPER"
          ></b-form-input>
          <span class="error" v-if="!noteModal.clientNameM">{{
            errorCDNote.clientNameM
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="CONSIGNEE">
            CONSIGNEE
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.consignee"
            type="text"
            placeholder="Enter CONSIGNEE"
          ></b-form-input>
          <span class="error" v-if="!noteModal.consignee">{{
            errorCDNote.consignee
          }}</span>
        </b-col>

        <b-col cols="4" class="mt-2">
          <label for="Destination">
            Destination
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.FinalPlace"
            type="text"
            placeholder="Enter Destination"
          ></b-form-input>
          <span class="error" v-if="!noteModal.FinalPlace">{{
            errorCDNote.FinalPlace
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Container No">
            Container No.
            <span class="error">*</span>
          </label>
          <b-form-input
            disabled
            :formatter="capitalizeAll"
            v-model="noteModal.containerNoArryNote"
            type="text"
            placeholder="Enter Container No"
          ></b-form-input>
          <span class="error" v-if="!noteModal.containerNoArryNote">{{
            errorCDNote.containerNoArryNote
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Container Type">
            Container Type
            <span class="error">*</span>
          </label>
          <b-form-input
            disabled
            :formatter="capitalizeAll"
            v-model="noteModal.containersTypes"
            type="text"
            placeholder="Enter Container Type."
          ></b-form-input>
          <span class="error" v-if="!noteModal.containersTypes">{{
            errorCDNote.containersTypes
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SHIPPER INV.">
            SHIPPER INV.
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.ShipperInvDet"
            type="text"
            placeholder="Enter SHIPPER INV. Details"
          ></b-form-input>
          <span class="error" v-if="!noteModal.ShipperInvDet">{{
            errorCDNote.ShipperInvDet
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Booking No">
            Booking No
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.validBookingNo"
            type="text"
            placeholder="Enter Booking No"
          ></b-form-input>
          <span class="error" v-if="!noteModal.validBookingNo">{{
            errorCDNote.validBookingNo
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SOB">
            SOB
            <span class="error">*</span>
          </label>

          <date-picker
            :format="selectDateFormat"
            lang="en"
            id="SOB"
            :minute-step="1"
            name="SOB"
            v-model="noteModal.SOB"
          ></date-picker>
          <span class="error" v-if="!noteModal.SOB">{{ errorCDNote.SOB }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="ETADest">
            ETA Dest
            <span class="error">*</span>
          </label>
          <date-picker
            :format="selectDateFormat"
            lang="en"
            id="ETADest"
            :minute-step="1"
            name="ETADest"
            v-model="noteModal.ETADest"
          ></date-picker>
          <span class="error" v-if="!noteModal.ETADest">{{ errorCDNote.ETADest }}</span>
        </b-col>
        <!-- <b-col cols="1"></b-col> -->
        <b-col cols="10">
          <table class="table table-sm table-bordered mt-2">
            <tbody style="background: white">
              <tr v-if="noteParticulars.length > 0">
                <th scope="col" style="width: 5px">SN.</th>
                <th scope="col" style="width: 600px">Particulars</th>
                <th scope="col" style="width: 600px">QTY</th>
                <th scope="col" style="width: 180px">Amount</th>
                <th scope="col" style="width: 180px">Final</th>
                <th scope="col" style="width: 180px">Selected Cont</th>
                <th scope="col" style="width: 180px">Currecny</th>
                <th scope="col" style="width: 5px">Actions</th>
              </tr>
              <tr v-for="(item, index) in noteParticulars" :key="index">
                <th scope="row">{{ index + 1 }}.</th>
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.parti"
                    placeholder="Enter Particular"
                  ></b-form-input>
                </td>
                <td>
                <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.qty"
                    placeholder="Enter Quantity"
                    @input="TotalAMT"
                  ></b-form-input>
                </td>
                <!-- <td>{{ item.qty }}</td> -->
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.amt"
                    type="number"
                    placeholder="Enter Amount"
                    v-on:keyup="TotalAMT"
                  ></b-form-input>
                </td>
                <td>{{ item.final_amt }}</td>
                <td>{{ item.container_selected }}</td>
                <td>
                  <model-list-select
                    :list="CurrencyList"
                    v-model="item.currency"
                    option-value="currency_id"
                    option-text="currencyCode"
                    placeholder="Select Currency"
                  ></model-list-select>
                </td>
                <td>
                  <b-button size="sm" @click="removeParti(index)">
                  <!-- <b-button v-if="index > 0" size="sm" @click="removeParti(index)"> -->
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                  </b-button>
                </td>
              </tr>
              <tr v-if="TotAMT != 0">
                <td colspan="2">
                  <b style="color: blue; font-weight: bold; font-size: 18px">Total</b>
                </td>
                <td colspan="3">
                  <b style="color: blue; font-weight: bold; font-size: 18px">{{
                    TotAMT
                  }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col cols="10">
          <label for="jj">Remarks</label>
          <!-- </b-col>
          <b-col cols="11">-->
          <b-form-textarea
            :formatter="capitalizeAll"
            v-model="noteModal.remarks"
            rows="3"
          ></b-form-textarea>
        </b-col>

        <b-col cols="10" class="text-center">
          <b-button
            :disabled="IsCDNotedisabled"
            class="mt-3"
            variant="success"
            v-if="noteParticulars.length > 0 && noteModal.AgentColoader"
            @click="submitNote"
            >Send for approval</b-button
          >
          <b-button class="mt-3" variant="outline-danger" @click="hideNoteModal"
            >Close</b-button
          >
        </b-col>
        <!-- <b-col cols="3"></b-col> -->
      </b-row>
    </b-modal>
    <!-- Added By Priyanshu SIngh End -->

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
    <!-- <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseSubmit"
      ref="addPopSubmit"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>-->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import CommonOverseaUnLock from "../common/commonOverseaUnLock.vue";
import EditCRDRNote from "../common/editCRDRNote.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";

export default {
  beforeMount() {
    // OVERSEAS AGENT ASSIGNMENTS
    // if (globalPermissionStatus("Sea Freight")) {
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllConsigneeList",
      JSON.stringify({
        itemCode: "ConsigneeList",
      })
    );
    this.$store.dispatch(
      "commonDropdownMaster/setAllAgentDDList",
      JSON.stringify({
        itemCode: "getAgentDDList",
        type: "Normal",
      })
    );
    if (globalPermissionStatus("Overseas Agent Assignments")) {
      // this.$store.dispatch("setCurrentRoute", "/overseas/ViewfclCon");
      this.$store.dispatch("setCurrentRoute", "/ffExportCon/viewFFConsoExport");
      this.viewFFExportFCL();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      lock_button: false,
      is_locked: "",
      locked_counter: "",

      // Added By Priyanshu Singh Start
      TotAMT: 0,
      ManifestationParticulars: [],
      IsCDNotedisabled: false,
      NoteData: "",
      errorCDNote: {
        // AgentColoader: "",
        AgentColoader: "",
        vesselVoy: "",
        BLNumber: "",
        masterorLinerBlNo: "",
        clientNameM: "",
        consignee: "",
        FinalPlace: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",
        validBookingNo: "",
        SOB: "",
        ETADest: "",
      },
      arrayErrorCDNote: [
        {
          // AgentColoader: "Please Select To",
          AgentColoader: "Please Select To",
          vesselVoy: "Please Enter Vessel/Voy ",
          BLNumber: "Please Enter HBL/AWB",
          masterorLinerBlNo: "Please Enter MBL/MAWB",
          clientNameM: "Please ENter SHIPPER",
          consignee: "Please Enter Consignee",
          FinalPlace: "Please Enter FPOD",
          containerNoArryNote: "Please Enter Container No.",
          containersTypes: "Please Enter Container Type",
          ShipperInvDet: "Please Enter SHIPPER INV",
          validBookingNo: "Please Enter Booking No",
          SOB: "Please Enter SOB",
          ETADest: "Please Enter ETA Destination",
        },
      ],
      selectDateFormat,
      allModuleId: "",
      ShowSendApproval: "",
      AgentColoaderList: [],
      noteParticulars: [],
      CurrencyList: [],
      containerTypeDetailFactory: [],
      note_id: "",
      getCLientData: ["gfdg"],
      getAllAgentColoaderList: [],
      agentTypeList: [
        {
          TypeVal: "Consignee",
          TypeTxt: "Consignee",
        },
        {
          TypeVal: "Agent",
          TypeTxt: "Agent",
        },
      ],
      noteModal: {
        agentType: "Agent",
        fk_agent_id: "",
        fk_consignee_id: "",
        agentconsigneeAddress: "",
        agent_country:"",

        shipper: "",
        branchName: "",
        branchList: [],
        AgentColoader: "",
        creditDebitNoteType: "",
        remarks: "",
        noteDate: "",
        note_id: "",
        noteContent: "",
        noteAmount: "",
        noteCurrency: "",
        ffExportFclId: "",
        allModuleId: "",
        fclBlId: "",
        BLNumber: "",
        uploadCreditDebit: "",
        sentForApproval: "",
        approvalStatus: "",
        masterorLinerBlNo: "",

        vesselVoy: "",
        clientNameM: "",
        consignee: "",
        FinalPlace: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",
        validBookingNo: "",
        SOB: "",
        ETADest: "",
        type: "",
      },
      //Added By Priyanshu SIngh End
      deliveryTermsList: [
        {
          value: "ExWorks",
          text: "EXWORKS",
        },
        {
          value: "FOB",
          text: "FOB",
        },
        {
          value: "CIF",
          text: "CIF",
        },
        {
          value: "DAP",
          text: "DAP",
        },
        {
          value: "DDU",
          text: "DDU",
        },
        {
          value: "DDP",
          text: "DDP",
        },
        {
          value: "CFR",
          text: "CFR",
        },
        {
          value: "FCA",
          text: "FCA",
        },
      ],
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      fields: [
        {
          key: "ffFclConsoExportId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ffExportFclConsoSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "clientName",
          label: "Client Name",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "placeRecp",
          label: "Other Details",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "MBL",
          label: "MBL,HBL/CONTAINERS",
          sortable: true,
          sortDirection: "desc",
        },
        //  {
        //   key: "BLNo",
        //   mainkey: "BLNo",
        //   label: "Bl No",
        //   class: "text-left",
        // },
        {
          key: "action",
          mainkey: "action",
          label: "Actions",
          class: "text-left",
        },
        {
          key: "eta_details",
          mainkey: "eta_details",
          label: "ETA Destination Details",
          class: "text-left",
        },
        {
          key: "manifestation",
          mainkey: "manifestation",
          label: "MANIFESTATION",
          class: "text-left",
        },
        {
          key: "closed",
          mainkey: "closed",
          label: "Close",
          class: "text-left",
        },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      isLoading: false,
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      FFExport: [],
      closedFilter: "2",
      ToFilter: "",
      agentFilter: "",
      SOBFilter: "3",
      
      termFilter:"",
      manifestationFilter: "1",
      termFilter:"",
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      ManifestationStatusList: [
        {
          inv: "1",
          int: "Recevied",
        },
        {
          inv: "2",
          int: "Pending",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      CLosedStatusList: [
        {
          inv: "1",
          int: "Closed",
        },
        {
          inv: "2",
          int: "Pending",
        },
       
        {
          inv: "3",
          int: "All (Within120 Days)",
        },
        {
          inv: "4",
          int: "Global ALL",
        },
      ],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    // Loading,
    CustomLoader,
    ModelListSelect,
    DocForm,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    AddMessage,
    AssignmentSummary,
    CommonOverseaUnLock,
    EditCRDRNote,
    ContainerSummary,
    JobWisePaymentsDetails,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },

  methods: {
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "frght_fclconsolidationexport",
          update_key: "ffFclConsoExportId",
          Title: tit,
          module_type: "FCL Consolidation Export",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.lock_button = false;
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => {});
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.ffFclConsoExportId;
      this.lock_ffExportFclSeries = items.ffExportFclConsoSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    sendMANIFESTATION(item) {
      // alert(item.fclConAlertId);
      // alert(item.allModuleId);
      // alert(item.ffFclConsoExportId);
      // return false;
      this.$sessionsStorage.set("sendManifest_ffFclConsoallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffFclConsoallModuleId", item.allModuleId);
      this.$sessionsStorage.set(
        "sendManifest_ffFclConsoExportId",
        item.ffFclConsoExportId
      );
      this.$router.push({
        path: "/ffExportCon/ffconsendManifestation",
      });
    },
    openCloseOverseasModal(item) {
      console.log("item=>", item);
      this.overseasClosedItems = item;
      this.$refs["CloseOverseas-modal"].show();
    },

    hideCloseOverseasModal() {
      this.$refs["CloseOverseas-modal"].hide();
    },
    SaveCloseOverseas() {
      console.log("overseasClosedItems=>", this.overseasClosedItems);
      // return false;

      let payload = {
        allModuleId: this.overseasClosedItems.allModuleId,
        ffFclConsoExportId: this.overseasClosedItems.ffFclConsoExportId,
        salesSeries: this.overseasClosedItems.ffExportFclConsoSeries,
      };
      //  console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Overseas/sendFCLCONSOLIDATIONOverseasCloseRequest.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      // this.hideCloseOverseasModal();
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "hj");
            this.hideCloseOverseasModal();
            this.viewFFExportFCL("0", "0", "1", "1");
          }
        })
        .catch((error) => {});
    },
    checkcreditDebitNote_Status(NoteDetails = []) {
      console.log(
        { NoteDetails },
        (NoteDetails || []).some((x) => x.creditDebitNote_Status == "credit")
      );

      return (NoteDetails || []).some((x) => x.creditDebitNote_Status == "credit");
    },
    PrintNote(ffExportFclConsoSeries, uploadCreditDebit) {
      //  alert(ffExportFclSeries);
      //  alert(uploadCreditDebit);
      let key =
        "ASSIGNMENT_UPLOADS/" +
        ffExportFclConsoSeries.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },
    checkActions(item) {
      console.log("ACtions => ", item);
      // alert(item.ffBookingId)

      this.$sessionsStorage.set("editSalesExId", item.allModuleId);
      this.$sessionsStorage.set("editffFclConsoExportId", item.ffFclConsoExportId);
      this.$sessionsStorage.set("editffConExecutionId", item.ffConExecutionId);
      this.$sessionsStorage.set("editconFclBookingId", item.conFclBookingId);

      //  ffFclConsoExportId: this.$sessionsStorage.get("editffFclConsoExportId"),
      //     ffConExecutionId: this.$sessionsStorage.get("editffConExecutionId"),
      //     conFclBookingId: this.$sessionsStorage.get("editconFclBookingId")

      if (item.portLocationType != "USA") {
        this.$router.push({
          path: "/ffExportCon/conBLNewNonUs",
        });
      } else {
        this.$router.push({
          path: "/ffExportCon/conBLSlineUs",
        });
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToMain() {
      this.$sessionsStorage.set("editffFclConsoExportId", "");
      this.$router.push({
        path: "/ffExportCon/ffExportFclConsolidation",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#po").DataTable();
      });
    },

    showDocModal(item) {
      console.log(item);
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.ffExportFclConsoSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },

    viewExportFCLConPage(FCLCONID) {
      this.$sessionsStorage.set("editffFclConsoExportId", FCLCONID);
      this.$router.push({
        path: "/ffExportCon/ffExportFclConsolidation",
      });
    },
    viewFFExportFCL() {
      this.isLoading = true;
      let payload = {
        view: "view",
        SOBFilter: this.SOBFilter,
        
        termFilter: this.termFilter,
        closedFilter: this.closedFilter,
        ToFilter: this.ToFilter,
        agentFilter: this.agentFilter,
        manifestationFilter: this.manifestationFilter,
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewOverseasFclCon.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            // alert(15715);
            // alert(data.ffExportDetails.length);
            console.log("data=>", data);
            if (data.ffExportDetails.length > 0) {
              this.FFExport = data.ffExportDetails;
              this.totalRows = data.ffExportDetails.length;
            } else {
              this.FFExport = [];
              this.totalRows = 0;
            }
            this.isLoading = false;
            this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
    // Added By Priyanshu SIngh Start
    addContent() {
      let obj = {
        parti: "",
        amt: "",
        currency: "1",
        qty:1,
        container_selected:1,
        final_amt:0,
      };
      this.noteParticulars.push(obj);
    },
    removeParti(index) {
      this.noteParticulars.splice(index, 1);
      this.TotalAMT();
    },
    validateCDNote() {
      let validate_new = true;
      Object.keys(this.errorCDNote).map((x, index) => {
        if (this.noteModal[x] == "") {
          this.errorCDNote[x] = this.arrayErrorCDNote[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    removeTags(str) {
      if (str === null || str === "") return false;
      else str = str.toString();
      return str.replace(/(<([^>]+)>)/gi, "");
    },
    getAgentConsigneeList(agentType) {
      this.noteModal.AgentColoader = "";
      if (agentType == "Agent") {
        this.getAllAgentColoaderList = this.$store.getters[
          "common/getAllAgentColoaderList"
        ];
      } else if (agentType == "Consignee") {
        this.getAllAgentColoaderList = this.$store.getters["common/getAllConsigneeList"];
      }
      this.noteModal.AgentColoader = "";
      console.log("AgentColoader Details=>", this.noteModal.AgentColoader);
    },
    getConsigneeAgentDetails() {
      this.noteModal.fk_consignee_id = "";
      this.noteModal.fk_agent_id = "";
      this.noteModal.agent_country = "";
      this.noteModal.agentconsigneeAddress = "";
      if (this.noteModal.agentType == "Consignee") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.noteModal.AgentColoader) {
            console.log("Consignee Details=>", val);
            this.noteModal.fk_consignee_id = val.agntColoaderId;
            this.noteModal.agentconsigneeAddress = val.address;
          }
        });
      } else if (this.noteModal.agentType == "Agent") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.noteModal.AgentColoader) {
            console.log("Agent Details=>", val);
            this.noteModal.fk_agent_id = val.agntColoaderId;
            this.noteModal.agent_country=val.countryName;
          }
        });
      }
    },
    submitNote() {
      this.validateCDNote();
      if (this.validate == false) return false;

      this.isLoading = true;
      this.ShowSendApproval = false;

      if (this.noteParticulars.length <= 0) {
        this.alert.content = "Please add particulars";
        this.$refs["addPop"].open();
        return false;
      }

      let noteParti = [];
      let noteAmt = [];
      let noteCurrency = [];
      // alert(this.NoteData.EmpLoc);
      this.noteModal["fk_currency_id"] = "";
      for (let i = 0; i < this.noteParticulars.length; i++) {
        noteParti.push(this.noteParticulars[i].parti);
        noteAmt.push(this.noteParticulars[i].final_amt ? this.noteParticulars[i].final_amt : 0);
        noteCurrency.push(
          this.noteParticulars[i].currency ? this.noteParticulars[i].currency : 0
        );
        this.noteModal["fk_currency_id"] = this.noteParticulars[i].currency
          ? this.noteParticulars[i].currency
          : "1";
      }
      let containerNoArryNote = [];
      this.NoteData.allContainer.map((x) => {
        containerNoArryNote.push(x.fclConcontainerNo);
      });
      let HouseBLArry = [];
      if (this.NoteData.BLNonData.length > 0) {
        this.NoteData.BLNonData.map((x) => {
          HouseBLArry.push(x.billLading);
        });
      }
      this.noteModal.noteContent = noteParti.toString();
      this.noteModal.noteAmount = noteAmt.toString();
      this.noteModal.noteCurrency = noteCurrency.toString();
      console.log("noteModal=>", this.noteModal);
      this.noteModal["containerNoArryNote"] = this.noteModal.containerNoArryNote
        ? this.noteModal.containerNoArryNote
        : containerNoArryNote.toString();
      this.noteModal["containerTypesArr"] = this.noteModal.containersTypes
        ? this.noteModal.containersTypes
        : this.NoteData.containersTypes;
      this.noteModal["ShipperInvDet"] = this.noteModal.ShipperInvDet
        ? this.noteModal.ShipperInvDet
        : this.NoteData.ShipperInvDet;
      this.noteModal["type"] = "FF Export";
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = this.NoteData.allModuleId;
      this.noteModal["agentName"] = this.NoteData.agentName;
      this.noteModal["overseas_agent"] = this.NoteData.overseas_agent;
      this.noteModal["agentAddress"] = this.NoteData.agentAddress;
      this.noteModal["vesselVoy"] = this.noteModal.vesselVoy
        ? this.noteModal.vesselVoy
        : this.NoteData.vesselVoy;
      var clientNameString = "";
      if (this.NoteData.clientName != "") {
        var clientNameArr = this.NoteData.clientName.split(",");
        var clientNameStr = $.unique(clientNameArr.sort());
        clientNameString = clientNameStr.toString();
      }
      // console.log('clientNameArr=>',clientNameArr);
      // console.log('clientNameStr=>',clientNameStr);
      // console.log('clientNameString=>',clientNameString);
      // return false;
      this.noteModal["shipper"] = this.noteModal.clientNameM
        ? this.noteModal.clientNameM
        : clientNameString;
      this.noteModal["consignee"] = this.noteModal.consignee
        ? this.noteModal.consignee
        : this.removeTags(this.NoteData.Newconsignee.replaceAll("&nbsp;", " "));
      this.noteModal["fclBlId"] = this.NoteData.fclBlId;
      this.noteModal["branchName"] = this.NoteData.EmpLoc;
      this.noteModal["FinalPlace"] = this.noteModal.FinalPlace
        ? this.noteModal.FinalPlace
        : this.NoteData.finalPlace;
      this.noteModal["masterorLinerBlNo"] = this.noteModal.masterorLinerBlNo
        ? this.noteModal.masterorLinerBlNo
        : this.NoteData.linerBLNumber;
      this.noteModal["BLNumber"] = this.noteModal.BLNumber
        ? this.noteModal.BLNumber
        : HouseBLArry.toString();
      // this.noteModal["BLNumber"] = this.NoteData.billLading;HouseBLArry
      // this.noteModal["BLNumber"] = this.NoteData.house_bl_no;
      this.noteModal["page"] = "consolidation";
      this.noteModal["salesSeries"] = this.NoteData.ffExportFclConsoSeries;
      this.noteModal[
        "salesSeriesUpload"
      ] = this.NoteData.ffExportFclConsoSeries.replaceAll("/", "_");
      this.noteModal["ffExportFclId"] =
        this.NoteData.ffFclConsoExportId != ""
          ? this.NoteData.ffFclConsoExportId
          : this.$sessionsStorage.get("editffFclConsoExportId");
      // alert(this.$sessionsStorage.get("editffFclConsoExportId"));
      this.noteModal["LPM"] = this.NoteData.LoadPort;
      this.noteModal["PODM"] = this.NoteData.placeDis;
      this.noteModal["PORM"] = this.NoteData.placeRecp;
      this.noteModal["clientNameM"] = this.noteModal.clientNameM
        ? this.noteModal.clientNameM
        : clientNameString;
      this.noteModal["shippingLineM"] = this.NoteData.shippingLine;
      this.noteModal["ASeriesM"] = this.NoteData.ffExportFclConsoSeries;
      this.noteModal["agentNameM"] = this.NoteData.agentName;
      this.noteModal["overseas_agentM"] = this.NoteData.overseas_agent;
      this.noteModal["ASDateM"] = this.NoteData.loginTime;
      this.noteModal["ToM"] = this.NoteData.AgentColoader;
      if (this.noteModal["vesselVoy"] == undefined) {
        this.noteModal["vesselVoy"] = "";
      }

      if (this.noteModal["fclBlId"] == undefined || this.noteModal["fclBlId"] == "") {
        this.noteModal["fclBlId"] = "0";
      }

      if (this.noteModal["agentAddress"] == undefined) {
        this.noteModal["agentAddress"] = "";
      }

      if (this.noteModal["masterorLinerBlNo"] == undefined) {
        this.noteModal["masterorLinerBlNo"] = "";
      }

      if (this.noteModal["BLNumber"] == "NaN") {
        this.noteModal["BLNumber"] = "";
      }

      this.noteModal["validBookingNo"] = this.noteModal.validBookingNo
        ? this.noteModal.validBookingNo
        : this.NoteData.validBookingNo;
      this.noteModal["SOB"] = this.noteModal.SOB
        ? this.noteModal.SOB
        : this.NoteData.sob_date_detected;
      this.noteModal["ETADest"] = this.noteModal.ETADest
        ? this.noteModal.ETADest
        : this.NoteData.ETA_destination_estimated;
      this.IsCDNotedisabled = true;
      console.log("this.noteModal=>", this.noteModal);
      // return false;
      if (this.validate != false) {
        console.log(this.noteModal);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addCreditDebitNoteNew_VP.php`,
          data: JSON.stringify(this.noteModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.IsCDNotedisabled = false;
              Object.keys(this.noteModal).map((x) => {
                this.noteModal[x] = "";
              });
              this.noteParticulars = [];
              this.$refs["note-modal"].hide();
              this.$refs["addPop"].open();
              // this.getData();
              this.viewFFExportFCL("0", "0", "1", "1");
            }
          })
          .catch((error) => {});
      }
    },
    // PrintNote(ffImportSeries,uploadCreditDebit) {
    //   window.open(
    //     `${this.docURL}/ASSIGNMENT_UPLOADS/` +
    //       ffImportSeries.replaceAll("/", "_") +
    //       "/" +
    //       uploadCreditDebit
    //   );
    // },
    getManifestationParticulars(allModuleId, id) {
      return new Promise((resolve) => {
        this.ManifestationParticulars = [];
        this.noteParticulars = [];
        let noteType = "";
        if (id == "1") {
          noteType = "CREDIT";
        } else if (id == "2") {
          noteType = "DEBIT";
        }
        let payload = {
          noteType: noteType,
          allModuleId: allModuleId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/getManifestationParticulars.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.manifestationParticulars.length > 0) {
                data.manifestationParticulars.forEach((element) => {
                  let obj = {
                    parti: element.ledgerId,
                    amt: element.amount,
                    currency: element.currency,
                    qty:element.container_count,
                    container_selected:element.container_selected,
                    final_amt:element.container_count*element.amount,
                  };
                  this.noteParticulars.push(obj);
                });
                console.log("manifestationParticulars=>", this.noteParticulars);
              } else {
                this.noteParticulars = [];
              }
              return resolve(this.noteParticulars);
            }
          })
          .catch((error) => {});
      });
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.CurrencyList = [];
        let payload = {
          Currency: "Currency_DropDown",
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/viewAllCurrencyList.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.CurrencyList.length > 0) {
                this.CurrencyList = data.CurrencyList;
              } else {
                this.CurrencyList = [];
              }
              return resolve(this.CurrencyList);
            }
          })
          .catch((error) => {});
      });
    },
    TotalAMT() {
      let TotAmount = 0;
      this.noteParticulars.forEach((value, index) => {
        let amount = 0;
        if (value.qty <= 0) {
          value.qty = 1;
        }
        if (isNaN(value.amt) || value.amt == "") {
          amount = 0;
        } else {
          amount = value.amt * value.qty;
        }
        value.final_amt = value.amt * value.qty;
        if (this.TotAMT == 0) {
          TotAmount = eval(amount);
        } else {
          TotAmount = eval(TotAmount) + eval(amount);
        }
        this.TotAMT = TotAmount;
      });
      console.log("this.totFinalAmount item=>", this.TotAMT);
      this.$forceUpdate();
    },
    async openNoteModal(id, item) {
      this.TotAMT = 0;
      let ParticularsArr = await this.getManifestationParticulars(item.allModuleId, id);
      let CurrencyArr = await this.getCurrencyList();
      if (this.noteParticulars.length > 0) {
        this.TotalAMT();
      }
      this.NoteData = "";
      this.containerTypeDetailFactory = [];
      this.NoteData = item;
      console.log("Priyanshu SIngh=>", item);
      // alert(this.NoteData.exclientName);
      this.noteModal.shipper = this.NoteData.exporterClientId;

      this.noteModal.creditcount = this.NoteData.creditcount;
      this.noteModal.debitcount = this.NoteData.debitcount;
      let creditnoteSeriesDetails = [];
      let debitnoteSeriesDetails = [];
      this.NoteData.NoteDetails.map((NS) => {
        if (NS.creditDebitNoteType == 1) creditnoteSeriesDetails.push(NS.noteSeries);
      });
      this.NoteData.NoteDetails.map((NS) => {
        if (NS.creditDebitNoteType == 2) debitnoteSeriesDetails.push(NS.noteSeries);
      });
      this.noteModal.creditnoteSeriesDetailsCount = creditnoteSeriesDetails.toString();
      this.noteModal.debitnoteSeriesDetailsCount = debitnoteSeriesDetails.toString();
      console.log("Single Note Details=>", item);
      console.log("this.NoteData=>", this.NoteData);

      let containerNoArryNote = [];
      item.allContainer.map((x) => {
        containerNoArryNote.push(x.fclConcontainerNo);
      });
      let HouseBLArry = [];
      if (item.BLNonData.length > 0) {
        item.BLNonData.map((x) => {
          HouseBLArry.push(x.billLading);
        });
      }
      console.log("noteModal=>", this.noteModal);
      this.noteModal.ffExportFclConsoSeries = item.ffExportFclConsoSeries;
      this.noteModal["containerNoArryNote"] = containerNoArryNote.toString();
      this.noteModal["containersTypes"] = item.containersTypes;
      this.noteModal["ShipperInvDet"] = item.ShipperInvDet;
      this.noteModal["type"] = "FF Export";
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = item.allModuleId;
      this.noteModal["agentName"] = item.agentName;
      this.noteModal["overseas_agent"] = item.overseas_agent;
      this.noteModal["agentAddress"] = item.agentAddress;
      this.noteModal["vesselVoy"] = item.vesselVoy;
      var clientNameString = "";
      if (item.clientName != "") {
        var clientNameArr = item.clientName.split(",");
        var clientNameStr = $.unique(clientNameArr.sort());
        clientNameString = clientNameStr.toString();
      }
      // console.log('clientNameArr=>',clientNameArr);
      // console.log('clientNameStr=>',clientNameStr);
      // console.log('clientNameString=>',clientNameString);
      // return false;
      this.noteModal["shipper"] = clientNameString;
      this.noteModal["consignee"] = this.removeTags(
        item.Newconsignee.replaceAll("&nbsp;", " ")
      );
      this.noteModal["fclBlId"] = item.fclBlId;
      this.noteModal["branchName"] = item.EmpLoc;
      this.noteModal["FinalPlace"] = item.finalPlace;
      this.noteModal["masterorLinerBlNo"] = item.linerBLNumber;
      this.noteModal["BLNumber"] = HouseBLArry.toString();
      // this.noteModal["BLNumber"] = item.billLading;HouseBLArry
      // this.noteModal["BLNumber"] = item.house_bl_no;
      this.noteModal["page"] = "consolidation";
      this.noteModal["salesSeries"] = item.ffExportFclConsoSeries;
      this.noteModal["salesSeriesUpload"] = item.ffExportFclConsoSeries.replaceAll(
        "/",
        "_"
      );
      this.noteModal["ffExportFclId"] =
        item.ffFclConsoExportId != ""
          ? item.ffFclConsoExportId
          : this.$sessionsStorage.get("editffFclConsoExportId");
      // alert(this.$sessionsStorage.get("editffFclConsoExportId"));
      this.noteModal["LPM"] = item.LoadPort;
      this.noteModal["PODM"] = item.placeDis;
      this.noteModal["PORM"] = item.placeRecp;
      this.noteModal["clientNameM"] = clientNameString;
      this.noteModal["shippingLineM"] = item.shippingLine;
      this.noteModal["ASeriesM"] = item.ffExportFclConsoSeries;
      this.noteModal["agentNameM"] = item.agentName;
      this.noteModal["overseas_agentM"] = item.overseas_agent;
      this.noteModal["ASDateM"] = item.loginTime;
      this.noteModal["ToM"] = item.AgentColoader;
      if (this.noteModal["vesselVoy"] == undefined) {
        this.noteModal["vesselVoy"] = "";
      }

      if (this.noteModal["fclBlId"] == undefined || this.noteModal["fclBlId"] == "") {
        this.noteModal["fclBlId"] = "0";
      }

      if (this.noteModal["agentAddress"] == undefined) {
        this.noteModal["agentAddress"] = "";
      }

      if (this.noteModal["masterorLinerBlNo"] == undefined) {
        this.noteModal["masterorLinerBlNo"] = "";
      }

      if (this.noteModal["BLNumber"] == "NaN") {
        this.noteModal["BLNumber"] = "";
      }
      this.noteModal["validBookingNo"] = item.validBookingNo;
      this.noteModal["SOB"] = item.sob_date_detected ? item.sob_date_detected : item.PSOB;
      this.noteModal["ETADest"] = item.ETA_destination_estimated;
      // return false;

      this.noteModal.creditDebitNoteType = id;
      this.$refs["note-modal"].show();
      this.getAgentColoaderList();
    },
    hideNoteModal() {
      this.noteModal.approvalStatus = "";
      this.noteModal.sentForApproval = "";
      this.noteContent = "";
      this.noteAmount = "";
      this.noteCurrency = "";
      this.note_id = "";
      this.noteModal.remarks = "";
      this.noteParticulars = [];
      this.$refs["note-modal"].hide();
      this.isLoading = false;
    },
    getAgentColoaderList() {
      let type_Size = {
        view: "jdjd",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/getAgentColoaderList.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options).then((result) => {
        const { statusText, status, data } = result;
        if (status == 200 && data) {
          this.AgentColoaderList = data.agentColoaderList;
        }
      });
    },
    uniqueString(clientName) {
      // alert(clientName);
      var clientNameString = "";
      if (clientName != "" && clientName != null && clientName != undefined) {
        var clientNameArr = clientName.split(",");
        // console.log('clientNameArr=>',clientNameArr);
        var clientNameStr = $.unique(clientNameArr.sort());
        clientNameString = clientNameStr.toString();
      }
      return clientNameString;
    },
    wordWrap,
    // wordWrap(str, maxWidth) {
    //   let newLineStr = "\n";
    //   let done = false;
    //   let res = '';
    //   while (str.length > maxWidth) {
    //     let found = false;
    //     // Inserts new line at first whitespace of the line
    //     for (let i = maxWidth - 1; i >= 0; i--) {
    //         if (this.testWhite(str.charAt(i))) {
    //             res = res + [str.slice(0, i), newLineStr].join('');
    //             str = str.slice(i + 1);
    //             found = true;
    //             break;
    //         }
    //     }
    //     // Inserts new line at maxWidth position, the word is too long to wrap
    //     if (!found) {
    //         res += [str.slice(0, maxWidth), newLineStr].join('');
    //         str = str.slice(maxWidth);
    //     }
    //   }
    //   return res + str;
    // },

    // testWhite(x)
    // {
    //   let white = new RegExp(/^\s$/);
    //   return white.test(x.charAt(0));
    // }
    // Added By Priyanshu SIngh End
  },
};
</script>
<style></style>



// WEBPACK FOOTER //
// overSeasFclCon.vue?0019c937